import React, {forwardRef, MutableRefObject, useEffect, useState} from "react";
import { Input } from "@rebass/forms";
import {FieldHelperProps, FieldInputProps, FieldMetaProps, useField} from "formik";
import {InputHelper, InputHelperOptionalParameters} from "./InputHelper";
import {Moment} from "moment";
import styled from "styled-components";
import {Button, Flex, Text} from "rebass";

export const FileInput: React.FC<{
  name: string;
  errorText?: string;
  helperParameters?: InputHelperOptionalParameters;
}> = ({name, errorText, helperParameters={label: name}}) => {
  const validate = (value) => {
    if (value === "") {
      return errorText || "Select a value";
    }
  };

  const [field, meta, helpers] = useField({ name, validate });

  const fileName = meta.value.split("\\").pop()

  return (
    <InputHelper meta={meta} helpers={helpers} {...helperParameters}>
      <input id="fileSelector" type="file" accept="image/png, image/jpeg"
             value={meta.value}
             onChange={(e) => {
              helpers.setValue(e.target.value)
            }}
             style={{display: "none"}}
      />

      <Flex  alignContent="center" alignItems="center">
        <Button variant="secondary" onClick={() => document.getElementById("fileSelector")?.click()}>Upload File</Button>
        <Text color="primary" paddingLeft={2}>{fileName}</Text>
      </Flex>

    </InputHelper>
  );
};

export const StyledFileSelector = styled.input<{width: number}>`
  width: ${props => props.width}px;
  display: inline;
  border: 0;
  border-bottom: 2px solid #dddddf;
  font-size: 16px;
  &:focus {
    outline: 0;
  }
`
